import { render } from "./WorkspaceForm.vue?vue&type=template&id=a633e804"
import script from "./WorkspaceForm.vue?vue&type=script&lang=js"
export * from "./WorkspaceForm.vue?vue&type=script&lang=js"

import exportComponent from "/usr/app/saas-stack/admin-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__